import Image from 'react-bootstrap/Image'

import TituloNegrito from './TituloNegrito'
import CardProdutoGenerico from './CardProdutoGenerico'

import { retornarTexto } from '../helpers/textoHelper'

import aves from '../images/aves.png'
import bovinos from '../images/bovinos.png'
import pescadosCamaroes from '../images/camaroes-e-pescados.png'
import suinos from '../images/suinos.png'
import caes from '../images/caes.png'
import gatos from '../images/gatos.png'
import equinos from '../images/equinos.png'

function ProdutosCertificadosProdutoSustentavel({ produtos, exibirMenu, resolucaoMobile, idioma, slugEmpresa }) {

    let produtosPorEspecie = {
        'Aves': produtos.filter((produto) => produto['Aves']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Bovinos': produtos.filter((produto) => produto['Bovinos']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Aqua - Peixes': produtos.filter((produto) => produto['Aqua - Peixes']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Cães': produtos.filter((produto) => produto['Cães']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Gatos': produtos.filter((produto) => produto['Gatos']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Suínos': produtos.filter((produto) => produto['Suínos']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Equinos': produtos.filter((produto) => produto['Equinos']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
    }

    // Produtos que não se encaixam em nenhuma seção de espécie (sem espécie marcada ou com espécie que não possui seção própria, como 'Aqua - Camarões')
    const produtosJaExibidos = new Set([].concat(...Object.values(produtosPorEspecie)))

    const produtosSemSecao = produtos.filter((produto) => !produtosJaExibidos.has(produto) && produtoExisteNoIdiomaSelecionado(produto))

    const estiloTexto = { fontSize: '20px', color: 'white' }
    const estiloIcone = { height: '35px' }

    function produtoExisteNoIdiomaSelecionado(produto) {
        let exibirProduto = false

        if (idioma === 'pt') {
            exibirProduto = true
        } else if (idioma === 'en') {
            if (produto['Descrição do produto (Inglês)']) {
                exibirProduto = true
            }
        } else if (idioma === 'es') {
            if (produto['Descrição do produto (Espanhol)']) {
                exibirProduto = true
            }
        } else if (idioma === 'fr') {
            if (produto['Descrição do produto (Francês)']) {
                exibirProduto = true
            }
        }

        return exibirProduto
    }

    function montarSecaoEspecie(titulo, especie, imagem) {
        return <div>
            <div style={{ gap: '10px' }} className='mt-5 d-flex align-items-center justify-content-center'>
                <Image style={estiloIcone} src={imagem} alt='logo' fluid />
                <span style={estiloTexto}>{titulo}</span>
            </div>
            <div style={{ gap: '20px' }} className='mb-2 mt-5 d-flex flex-wrap align-items-center justify-content-center'>
                {produtosPorEspecie[`${especie}`]?.map((produto) => <CardProdutoGenerico key={produto['Nome do produto/serviço']} exibirMenu={exibirMenu} produto={produto} resolucaoMobile={resolucaoMobile} idioma={idioma} slugEmpresa={slugEmpresa} pathCatalogo={'catalogo-produto-sustentavel'} />)}
            </div>
        </div>
    }

    return (
        <>
            <TituloNegrito texto={retornarTexto(idioma, 'produtosCertificados')} />
            <div style={{ width: '80vw' }} className='mb-2 d-flex flex-column align-items-center justify-content-center'>

                {/* Produtos sem seção de espécie */}
                {produtosSemSecao.length > 0 ? <div style={{ gap: '20px' }} className='mb-2 mt-5 d-flex flex-wrap align-items-center justify-content-center'>
                    {produtosSemSecao.map((produto) => <CardProdutoGenerico key={produto['Nome do produto/serviço']} exibirMenu={exibirMenu} produto={produto} resolucaoMobile={resolucaoMobile} idioma={idioma} slugEmpresa={slugEmpresa} pathCatalogo={'catalogo-produto-sustentavel'} />)}
                </div> : <></>}

                {/* Aqua */}
                {produtosPorEspecie['Aqua - Peixes']?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Aqua' : idioma === 'fr' ? 'Aqua' : idioma === 'es' ? 'Aqua' : 'Aqua', 'Aqua - Peixes', pescadosCamaroes) : <></>}

                {/* Aves */}
                {produtosPorEspecie?.Aves?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Poultry' : idioma === 'fr' ? 'Volailles' : idioma === 'es' ? 'Aves' : 'Aves', 'Aves', aves) : <></>}

                {/* Bovinos */}
                {produtosPorEspecie?.Bovinos?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Cattle' : idioma === 'fr' ? 'Bovins' : idioma === 'es' ? 'Ganado' : 'Bovinos', 'Bovinos', bovinos) : <></>}

                {/* Cães */}
                {produtosPorEspecie?.Cães?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Dogs' : idioma === 'fr' ? 'Chiens' : idioma === 'es' ? 'Perros' : 'Cães', 'Cães', caes) : <></>}

                {/* Equinos */}
                {produtosPorEspecie?.Equinos?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Equines' : idioma === 'fr' ? 'Équidés' : idioma === 'es' ? 'Equinos' : 'Equinos', 'Equinos', equinos) : <></>}

                {/* Gatos */}
                {produtosPorEspecie?.Gatos?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Cats' : idioma === 'fr' ? 'Chats' : idioma === 'es' ? 'Gatos' : 'Gatos', 'Gatos', gatos) : <></>}

                {/* Suínos */}
                {produtosPorEspecie?.Suínos?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Swine' : idioma === 'fr' ? 'Porcs' : idioma === 'es' ? 'Cerdos' : 'Suínos', 'Suínos', suinos) : <></>}

            </div>
        </>
    );
}
export default ProdutosCertificadosProdutoSustentavel;
